import { toJson, toString } from './json'

export const getSessionStorageData = (key) => {
  try {
    return toJson(sessionStorage.getItem(key))
  } catch (error) {
    return sessionStorage.getItem(key)
  }
}

export const setSessionStorageData = (key, data) => {
  sessionStorage.setItem(key, toString(data))
}

export const deleteSessionStorage = (key) => {
  sessionStorage.removeItem(key)
}
